import { FC, SVGProps } from 'react';

export const SearchIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none" {...props}>
		<path
			d="M5.5719 7.64784H4.72758C2.886 7.64784 1.39282 9.14101 1.39282 10.9826L1.39282 15.3942C1.39282 17.2349 2.886 18.7281 4.72758 18.7281H14.7997C16.6413 18.7281 18.1345 17.2349 18.1345 15.3942V10.9735C18.1345 9.13739 16.6458 7.64784 14.8097 7.64784H13.9563"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M9.76343 1.50018V12.3967"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M7.12549 4.14996L9.76343 1.50026L12.4023 4.14996"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
